import React from "react";
import Header from "./Header";

const PageLayout = ({ children, variant = "light" }) => {
  const bg = variant === "dark" ? "bg-slate-900" : "bg-background";

  return (
    <div className={`min-h-screen ${bg}`}>
      <Header />
      <main className="main-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</div>
      </main>
    </div>
  );
};

export default PageLayout;
